module.exports = __webpack_public_path__ + "media/images/lcbh-76ac93899a01847b30281a1d9da5e83e.png";